import React, { useState, useEffect  } from 'react';
import { Container, Row, Col, Modal } from "react-bootstrap";
import BannerForm from "../../components/bannerfrom";
import {Link} from 'gatsby';

const Topgradecta = () => {
  const [show, setShow] = useState(false);
    
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    // Load Calendly script when the component mounts
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    // Cleanup script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
    <div className="top_grade_cta p-100" style={{ backgroundColor: "#F0792D" }} id="calendlycode">
        <Container className="h-100">
                <Row  className="h-100">
                    <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
                            <h2>A Top-Grade Web Development Company</h2>
                        <p>We're your digital architects, crafting immersive online experiences that captivate and convert. Schedule a meeting with us to transform your vision into a standout web presence.</p>
                        <Link to="#"
                              className="border_btn" aria-label="TekRevol Contact"  onClick={handleShow}>Let's Connect</Link>
                         <p>Schedule a meeting with us to transform your vision into a standout web presence.</p>      
                    </Col>
                    <Col xs={12} md={6} lg={8} xl={8} xxl={8} className="my-auto"> 
                    <div className="calendly-inline-widget" data-url="https://calendly.com/jbrown-uim/30min" style={{ minWidth: 320, height: 670 }}></div>  
                    </Col>
                </Row>
            </Container>
    </div>
    <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="landing_lp_popup"
      >
        <div className="modal_forms">
          <BannerForm setShow={setShow} />
        </div>
      </Modal>
    </>
  )
}

export default Topgradecta